<template lang="pug" src="./attachment.pug">
</template>

<script>
import { ref, reactive, watch } from '@vue/composition-api';

export default {
  name: 'Attachment',

  props: {
    requirements: {
      type: Array,
      required: true,
    },
    errors: {
      default: null,
    },
    paymentMethods: {
      default: [],
    },
    value: {
      type: Object,
      required: true,
      default() {
        return {
          requirements: [],
          proofOfPayment: [],
        };
      },
    },
  },

  emits: ['prev', 'validate', 'next'],

  setup(props, { emit }) {
    const selectedMethod = ref(null);
    const FileCpmt = ref(null);
    const ProofOfPaymentInputCpmt = ref(null);
    const currentReqId = ref(null);
    const form = reactive(props.value);
    const prev = () => {
      emit('prev');
    };
    const next = () => {
      emit('next');
    };
    const handleFileChange = (e) => {
      // console.log(e.target.files, currentReqId.value);
      const inputFiles = [...e.target.files];
      const requirements = [...form.requirements];
      for (let i = 0; i < requirements.length; i++) {
        const _req = requirements[i];
        if (_req.id == currentReqId.value) {
          // const files = _req.files;
          const inputFile = inputFiles[0];
          if (!_req.files.map((o) => o.name).includes(inputFile.name)) {
            _req.files = [..._req.files, inputFile];
            requirements[i] = { ..._req };
          }
          break;
        }
      }
      emit('input', form);
      emit('validate');
    };
    const handleUpload = (reqId) => {
      // console.log('handleUpload', reqId)
      currentReqId.value = reqId;
      // console.log('FileCpmt.value', FileCpmt.value);
      FileCpmt.value.value = null;
      FileCpmt.value.click();
      // const f = form.value.find(o => o.id == reqId)
      // if(!f) {
      //   form.value = [...form.value, {id: reqId, files: []}]
      // }
      // emit('input', form.value);
    };
    const handleRemoveRequirement = (reqIndex, fileIndex) => {
      // console.log('handleRemoveRequirement', reqIndex, fileIndex)
      const requirements = [...form.requirements];
      const requirement = requirements[reqIndex];
      if (requirement) {
        requirement.files.splice(fileIndex, 1);
        requirements[reqIndex] = requirement;
        form.requirements = requirements;
        emit('input', form);
        emit('validate');
      }
    };
    const handleProofOfPayment = () => {
      ProofOfPaymentInputCpmt.value.value = null;
      ProofOfPaymentInputCpmt.value.click();
    };
    const handleProofOfPaymentFileChange = (e) => {
      // console.log('Files', e.target.files)
      const files = [...form.proofOfPayment];
      const newFiles = e.target.files;
      if (newFiles.length > 0) {
        const newFile = newFiles[0];
        let alreadyOnList = false;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.name == newFile.name) {
            alreadyOnList = true;
            break;
          }
        }
        if (!alreadyOnList) {
          files.push(newFile);
        }
        form.proofOfPayment = files;
        emit('input', form);
      }
    };
    const handleProofOfPaymentRemove = (index) => {
      const files = [...form.proofOfPayment];
      files.splice(index, 1);
      form.proofOfPayment = files;
      emit('input', form);
    };
    watch(
      () => props.requirements,
      (currentVal) => {
        form.requirements = currentVal.map((o) => ({
          name: o.name,
          id: o.id,
          files: [],
          docs: o.pivot.docs,
        }));
        emit('input', form);
      }
    );
    const handlePaymentMethodChage = (e) => {
      form.paymentMethod = e.target.value;
      const selected = props.paymentMethods.find((method) => method.id == form.paymentMethod);
      // console.log('Selected method', selected, form.paymentMethod)
      selectedMethod.value = selected;
      emit('input', { ...form });
    };
    return {
      prev,
      next,
      form,
      FileCpmt,
      selectedMethod,
      handleFileChange,
      handleUpload,
      handleRemoveRequirement,
      ProofOfPaymentInputCpmt,
      handleProofOfPayment,
      handleProofOfPaymentFileChange,
      handleProofOfPaymentRemove,
      handlePaymentMethodChage,
    };
  },
};
</script>
